import React, {useCallback, useState} from 'react';
import {connect} from 'react-redux';
import './Login.scss';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import loginImage from '../../../images/emergencias-login.png';
import logo from '../../../images/logo-contigo-color.png';
import {useFormik} from 'formik';
import actions from '../../../redux/actions';
import {Redirect, useHistory} from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';
import {toast} from 'react-toastify';
import {Input} from '@mui/material';
import {IconButton, InputAdornment} from '@material-ui/core';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */
const Login = ({login, isLoggedIn, switchOfUser}) => {
    // eslint-disable-next-line react/prop-types
    const [showPassword, setShowPassword] = useState(false);

    const history = useHistory();

    const {executeRecaptcha} = useGoogleReCaptcha();

    // Create an event handler so you can call the verification on button click event or form submit
    const handleReCaptchaVerify = useCallback(async (values) => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        const token = await executeRecaptcha('yourAction');
        // Do whatever you want with the token
        if (token) {
            login({...values, captchaResponse: token});
            switchOfUser('Inicio');
        } else {
            toast.error('Error con reCaptcha');
        }
        // eslint-disable-next-line
    }, [executeRecaptcha]);


  const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },

        onSubmit: (values) => {
            handleReCaptchaVerify(values);
        },
    });

    return isLoggedIn ?
        <Redirect to='/home'/> :
        (
        <div className="lg-div-background">
            <div className="lg-div-cont element-to-hide">
                <img src={loginImage} alt={'login'} style={{borderRadius: 200}} className="lg-img"/>
            </div>
            <div className="lg-div-cont flex-1">
                <div className="lg-div-section width-80">
                    <img src={logo} alt={'logo'} className="lg-logo"/>
                    <form onSubmit={formik.handleSubmit}>
                        <Input
                            id="email"
                            name="email"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.email}
                            placeholder="Ingrese su email"
                            className="lg-input"/>
                        <div className="lg-div-password">
                            <Input
                                id="password"
                                name="password"
                                type={showPassword ? 'text' : 'password'}
                                onChange={formik.handleChange}
                                value={formik.values.password}
                                placeholder="Ingrese su contraseña"
                                className="lg-input-password"
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <Ebutton
                            classNameButton="lg-btn"
                            text="INICIAR SESION"
                            type="submit"/>
                    </form>
                    <a href='/recovery-password' className="lg-a"
                        onClick={()=>{
                            history.push('/recovery-password');
                        }}
                    >Olvidé mi contraseña</a>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isLoggedIn: state.login.isLoggedIn,
    loginState: state.login.loginState,
});

const mapDispatchToProps = (dispatch) => ({
    login: (body) => dispatch(actions.login.loginRequest(body)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
});

Login.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(Login);

